export type Currency = 'USD' | 'BRL'

type Locale = 'en-US' | 'pt-BR'

type FormatCurrencyOptions = {
  locale?: Locale
  currency?: Currency
}

export const formatCurrency = (
  val: number,
  isSpaceCard = false,
  { locale = 'en-US', currency = 'USD' }: FormatCurrencyOptions = {}
) => {
  const safeValue = isNaN(val) ? 0 : val ?? 0
  if (isSpaceCard) {
    const isInteger = Number.isInteger(safeValue)
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      minimumFractionDigits: isInteger ? 0 : 2,
      maximumFractionDigits: 2,
    }).format(safeValue)
  }
  return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(safeValue)
}
